var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ordenes",
    transform: "translate(-1113.000000, -124.000200)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(818.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    transform: "translate(295.500000, 9.300049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2857154,1.71428448 L12.5714304,1.71428448 L12.5714304,0.571439328 C12.571432,0.25583688 12.3155943,0 12,0 C11.6843896,0 11.4285534,0.25583688 11.4285534,0.571439328 L11.4285534,1.71428448 L4.57141449,1.71428448 L4.57141449,0.571439328 C4.57141449,0.25583688 4.3155775,0 4,0 C3.68443966,0 3.42856907,0.25583688 3.42856907,0.571439328 L3.42856907,1.71428448 L1.71428453,1.71428448 C0.767510656,1.71428448 0,2.48179504 0,3.42856912 L0,14.2857152 C0,15.2324896 0.767510656,16 1.71428453,16 L14.2857159,16 C15.2324905,16 16,15.2324896 16,14.2857152 L16,3.42856912 C16,2.48179504 15.2324899,1.71428448 14.2857154,1.71428448 L14.2857154,1.71428448 Z M14.8570993,14.2857102 C14.8570993,14.6013125 14.6012628,14.857149 14.2856602,14.857149 L1.71426161,14.857149 C1.39865915,14.857149 1.1428223,14.6013125 1.1428223,14.2857102 L1.1428223,6.857132 L14.8570993,6.857132 L14.8570993,14.2857102 L14.8570993,14.2857102 Z M14.8571643,5.7142804 L1.1428223,5.7142804 L1.1428223,3.42855613 C1.1428223,3.11295357 1.39865914,2.8571167 1.71426171,2.8571167 L3.42854629,2.8571167 L3.42854629,3.99996209 C3.42854629,4.31556448 3.68438309,4.57140149 3.99998561,4.57140149 C4.31558842,4.57140149 4.57142494,4.31556448 4.57142494,3.99996209 L4.57142494,2.8571167 L11.4285623,2.8571167 L11.4285623,3.99996209 C11.4285623,4.31556448 11.6843993,4.57140149 12.0000019,4.57140149 C12.3156042,4.57140149 12.5714402,4.31556448 12.5714402,3.99996209 L12.5714402,2.8571167 L14.2857261,2.8571167 C14.6013282,2.8571167 14.8571643,3.11295357 14.8571643,3.42855613 L14.8571643,5.7142804 L14.8571643,5.7142804 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.22208e7ee8d94802508ec4fb4abc2f88.svg";
export { ForwardRef as ReactComponent };